import { render, staticRenderFns } from "./PayerDataSummary.vue?vue&type=template&id=6f9f233d&scoped=true"
import script from "./PayerDataSummary.vue?vue&type=script&lang=js"
export * from "./PayerDataSummary.vue?vue&type=script&lang=js"
import style0 from "./PayerDataSummary.vue?vue&type=style&index=0&id=6f9f233d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f233d",
  null
  
)

export default component.exports